"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _SubMenuWithIframe = require("./SubMenuWithIframe.styles");
const ItemSkeletonWrapper = _ref => {
  let {
    width
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.ItemSkeleton, null, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 18,
    width: width
  }));
};
const SubMenuWithIframeSkeleton = _ref2 => {
  let {
    testId
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.ContainerWrapper, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(ItemSkeletonWrapper, {
    width: "80%"
  }), /*#__PURE__*/_react.default.createElement(ItemSkeletonWrapper, {
    width: "50%"
  }), /*#__PURE__*/_react.default.createElement(ItemSkeletonWrapper, {
    width: "60%"
  }));
};
var _default = exports.default = SubMenuWithIframeSkeleton;